/* eslint-disable camelcase */
import React, { useState, useEffect } from 'react';
import KickImage from 'Reuseables/KickImage';
import { connect } from 'react-redux';

// ========= module component import section ========= //
import { Modal } from 'reactstrap';
import { IconContext } from 'react-icons';
import { GrClose } from 'react-icons/gr';
// ====== end of module component import section ====== //

type stateToProps = {};

interface ModalCurrent extends stateToProps {
  isOpen: boolean;
  onToggle: () => any;
}

/**
 * Modal for Foreign Location on User Dashboard section for Kick Avenue 3.0 Website.
 * Author: Rifqy Zacky Ariadhy (rifqyzackya@gmail.com)
 * ===============================================
 * @param {ModalCurrent} props for this component.
 * @return {JSX.Element}
 */
function ModalForeignLocation({ isOpen, onToggle }: ModalCurrent): JSX.Element {
  return (
    <Modal
      className="foreign-location-modal"
      toggle={onToggle}
      isOpen={isOpen}
      centered
    >
      <>
        <p className={'text'}>
          Please email our International Sellers Center at{' '}
          <span className={'green'}>sellers-global@kickavenue.com</span>
        </p>

        <div className={'close-button'} onClick={onToggle}>
          <IconContext.Provider value={{ color: '#242424', size: '12px' }}>
            <div>
              <GrClose />
            </div>
          </IconContext.Provider>
        </div>
      </>
    </Modal>
  );
}

const mapStateToProps = (state: stateToProps) => {
  return {};
};

const mapDispatchToProps = (dispatch: (arg0: any) => any) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ModalForeignLocation);
